let colorStyle = { color: '#FA4B54' }

export default function useGetCheckBillAmountText(displayData) {
  return {
    amountInfoText: (
      <p
        style={{
          textAlign: 'right',
          margin: '20px 0',
          fontSize: '16px'
        }}>
        共 <span style={colorStyle}>{displayData.checkProductTypeNum}</span>{' '}
        种商品，盘点数量{' '}
        <span style={colorStyle}>{displayData.checkAllNum}</span> 总
        {displayData.checkDifferentAmount > 0 ? '盘盈' : '盘亏'}
        <span style={colorStyle}>
          {displayData.checkDifferentAmount !== undefined &&
            Math.abs(displayData.checkDifferentAmount)}
        </span>
        元
      </p>
    )
  }
}
